import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { LayoutModule } from './layout/layout.module';
import { Interceptors } from './interceptors';

import { authInitializer } from '@app/shared/initializers';
import { AuthService } from '@app/auth/services/auth.service';
import { AuthDOS } from '@app/auth/services/auth-dos.service';
import { MessageService } from '@app/services/message.service';
import { AppConfigService } from '@app/services/app-config.service';
import { GtagService } from '@app/services/gtag.service';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, BrowserAnimationsModule, SharedModule, AppRoutingModule, LayoutModule],
  providers: [
    Interceptors,
    GtagService,
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    {
      provide: APP_INITIALIZER,
      useFactory: authInitializer,
      deps: [AuthService, AuthDOS, MessageService, AppConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
